module.exports = __webpack_public_path__ + "static/media/studio_electric_forklift_truck_me_315_manitou_001.10d8bc7a.png";